import { Component } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center p-6">
          <div className="text-center max-w-md">
            <div className="h-16 w-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="h-8 w-8 text-red-400" />
            </div>
            <h2 className="text-lg font-bold text-[#0F172A] mb-2">Sesuatu Tidak Kena</h2>
            <p className="text-sm text-[#6B7280] mb-6">
              Halaman ini mengalami masalah. Sila muat semula atau kembali ke dashboard.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
                className="inline-flex items-center justify-center h-10 px-4 rounded-md text-sm font-medium bg-[#9333EA] hover:bg-[#7E22CE] text-white transition-colors"
                data-testid="error-boundary-reload"
              >
                <RefreshCw className="h-4 w-4 mr-2" /> Muat Semula
              </button>
              <button
                onClick={() => { this.setState({ hasError: false, error: null }); window.location.href = '/dashboard'; }}
                className="inline-flex items-center justify-center h-10 px-4 rounded-md text-sm font-medium border border-zinc-200 bg-white hover:bg-zinc-50 text-zinc-900 transition-colors"
                data-testid="error-boundary-dashboard"
              >
                Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
